module.exports = __webpack_public_path__ + "img/article-thumb.1d5bc726.png";